import { render, staticRenderFns } from "./zzkt.vue?vue&type=template&id=6bdbd67d&scoped=true"
import script from "./zzkt.vue?vue&type=script&lang=js"
export * from "./zzkt.vue?vue&type=script&lang=js"
import style0 from "./zzkt.vue?vue&type=style&index=0&id=6bdbd67d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdbd67d",
  null
  
)

export default component.exports